import { apiClient } from './ApiClient';
export const usersApi = {
    async list() {
        const response = await apiClient.get('/users');
        return response.data.users;
    },
    async get(id) {
        const response = await apiClient.get(`/users/${id}`);
        return {
            user: response.data.user,
            accessiblePrototypeIds: response.data.accessiblePrototypeIds ?? [],
        };
    },
    async invite(data) {
        const response = await apiClient.post('/users/invite', data);
        return response.data.invitation;
    },
    async acceptInvitation(data) {
        const response = await apiClient.post('/users/accept-invitation', data);
        return response.data.user;
    },
    async updateAccess(userId, data) {
        const response = await apiClient.put(`/users/${userId}/access`, data);
        return response.data;
    },
    async deactivate(userId) {
        await apiClient.post(`/users/${userId}/deactivate`);
    },
    async reactivate(userId) {
        const response = await apiClient.post(`/users/${userId}/reactivate`);
        return response.data;
    },
    async updateRole(userId, data) {
        const response = await apiClient.put(`/users/${userId}/role`, data);
        return response.data;
    },
    async delete(userId) {
        await apiClient.delete(`/users/${userId}`);
    },
    async listInvitations() {
        const response = await apiClient.get('/users/invitations');
        return response.data.invitations;
    },
    async revokeInvitation(invitationId) {
        await apiClient.delete(`/users/invitations/${invitationId}`);
    },
};
